import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const NewYorkUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="New York University"
      universityShortName="NYU"
      slug="new-york-university"
      seoTitle="NYU Study Rooms | Bobst Library Study Spaces New York"
      seoDescription="Find study rooms at NYU including Bobst Library group rooms. Learn booking policies, alternative spaces, and discover CSW as an online alternative."
      seoKeywords="NYU study rooms, Bobst Library study rooms, New York University library, Manhattan study spaces, NYU group study rooms"
      canonicalUrl="/study-room/new-york-university/"
      heroDescription="Navigate NYU's crowded study spaces and discover hidden gems beyond Bobst Library."
      libraryWebsiteUrl="https://library.nyu.edu"
      libraryWebsiteName="NYU Libraries"
      studySpaces={[
        {
          name: "Bobst Library - Group Rooms",
          features: "Levels 1, 2 and floor 7. Hold 4-12 people, 3 hours/day, book 14 days ahead.",
          feedback: "Notoriously crowded. 10-minute grace period before cancellation."
        },
        {
          name: "Stern School of Business - Lounges",
          features: "3rd and 4th floor lounges, natural light, comfortable seating.",
          feedback: "Great alternative to crowded Bobst. Sunny and less busy."
        },
        {
          name: "Kimmel Center - Lounges",
          features: "7th-9th floor lounges with views of Washington Square Park.",
          feedback: "Natural light and comfortable seating. Popular but spacious."
        },
        {
          name: "John A. Paulson Center",
          features: "Quieter, more spacious study areas.",
          feedback: "Newer facility with modern amenities. Less crowded."
        }
      ]}
      guideContent={
        <>
          <p>
            NYU's Bobst Library provides group study rooms on lower levels 1 and 2 and on floor 7. Rooms hold 4-12 people 
            and can be reserved for three hours per day, up to 14 days in advance.
          </p>
          <p className="mt-4">
            Policies prohibit one person from reserving a room for themselves, forbid "claiming" a room by leaving belongings, 
            and enforce a 10-minute grace period before cancellation.
          </p>
          <p className="mt-4">
            Bobst is notorious for being crowded. To escape the crowds, try the lounges on the 3rd and 4th floors of Stern, 
            the Kimmel Center lounges with views of Washington Square Park, or the John A. Paulson Center. 
            For a caffeine fix, stop by the third-floor café in Bobst.
          </p>
        </>
      }
      summaryTips={[
        "Book Bobst rooms up to 14 days in advance",
        "10-minute grace period before reservation cancellation",
        "Stern lounges are a sunny, less crowded alternative",
        "Kimmel Center offers views of Washington Square Park",
        "Cannot reserve a room for yourself alone"
      ]}
    />
  );
};

export default NewYorkUniversity;
